// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"SlateEditor_toolbar__PBNyV","editorContent":"SlateEditor_editorContent__lDsJq"};